export default __webpack_public_path__ + "static/media/smart_contract_icon.5bb0522a.png";